import { lazy } from "react";

import CertificateIcon from "../../../../../src/assets/images/certificatee-icon.svg";

import LottieAnimationFile from "../../../../assets/lotties/certificate-confetti.json";

import Modal from "../../../modal/Modal";

import Button from "../ButtonComponent";
import { BUTTON_VARIANTS } from "../constant";

import styles from "./styles.module.scss";

import { LMS_MODULE_NAME } from "../../../../utils/cookiesmanager";
import { useGetTranslatedText } from "../queries";
import { getTranslatedText } from "../../../../utils/getTranslatedText";

const LottiePlayerClient = lazy(() => import("../Lottie/index"));

const ModuleCertificateStatusModal = (props) => {
  const { show , handleRedirection } = props;

  const userData  = localStorage.getItem('user');

  const {firstName , lastName} = JSON.parse(userData) || {};

  const moduleName = localStorage.getItem(LMS_MODULE_NAME);
 
  const languageId = localStorage.getItem("l_id") || 1;
  
  const {data:translatedTextResponse} = useGetTranslatedText(languageId)
        
  const {data:translatedText = []} = translatedTextResponse || {};

  const userTypeId =  localStorage.getItem("userTypeId") || 1;

  
  
  return (
    <>
      <Modal visible={show}>
        <div className={styles["certificate-wrapper"]}>
          <div className={styles["confetti-wrapper"]}>
            <LottiePlayerClient
              animationData={LottieAnimationFile}
              loop={false}
              autoplay
            />
          </div>

          <div className={styles["content-wrapper"]}>
            <div className={styles["certificate-icon"]}>
              <img src={CertificateIcon} alt="" />
            </div>

            <div className={styles.title}>Dear {firstName || ''} {lastName || ''}</div>

            <div className={styles.description}>
            { userTypeId === '12' ? <p>{getTranslatedText(translatedText ,"key_completed_module" ,'You have successfully completed the module')}</p> :
             <>
              {getTranslatedText(translatedText ,"key_certificate_ready" ,'Your certificate is ready for the')} {[moduleName]}
              <p className={styles["para-text"]}>
                {getTranslatedText(translatedText , 'key_download_certificate_menu' , 'You can download it from the Certificate menu.')}
              </p>
              </>
              }
            </div>

            <div className={styles["button-wrapper"]}>
              <Button
                label={getTranslatedText(translatedText ,"key_back_to_module" , "Back to Module")}
                buttonVariant={BUTTON_VARIANTS.PRIMARY}
                className={styles["button"]}
                onClick={handleRedirection}
              />
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModuleCertificateStatusModal;
